import { render, staticRenderFns } from "./PaperTest.vue?vue&type=template&id=933c955a&style=height%3A%20100%25%3B%20%20%20%20%20background-color%3A%20rgba(11%2C%2045%2C%2061%2C%201)%3B"
import script from "./PaperTest.vue?vue&type=script&lang=js"
export * from "./PaperTest.vue?vue&type=script&lang=js"
import style0 from "./PaperTest.vue?vue&type=style&index=0&id=933c955a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports